export default __webpack_public_path__ + "static/media/su-logo-blue-2x.1966e2d7.png";